import * as React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  useNotify,
  useRefresh,
  useRedirect,
  required,
  ImageInput,
  ImageField,
} from 'react-admin';

export const AdsCreate = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = ({ data }) => {
    console.log(data);
    notify(`Created "${data.code}" ads`);
    redirect('/ads');
    refresh();
  };
  return (
    <Create onSuccess={onSuccess} {...props}>
      <SimpleForm>
        <ImageInput
          source="image"
          label="Ads picture"
          accept="image/*"
          multiple={false}
          placeholder={<p>Drop your images here</p>}
        >
          <ImageField source="image" />
        </ImageInput>
        <TextInput source="id" validate={[required()]} />
        <TextInput
          source="name"
          label="Business Name"
          validate={[required()]}
        />
        <TextInput source="description" validate={[required()]} />
        <TextInput source="url" validate={[required()]} />
      </SimpleForm>
    </Create>
  );
};
